export const LABELLING_CATEGORY = {
  DECORATIVE: "DECORATIVE",
  LABEL: "LABEL",
};

export const LABELLING_ITEM_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  LABEL: "LABEL",
};
